import { createContext } from 'react'
import { RequestStatus } from '../responses/response'

export const hoverContext = createContext<boolean>(false)
export const statusContext = createContext(RequestStatus.INITIAL)
export const inactiveContext = createContext(false)